import React, { createContext, useContext, useState, useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { projectKeys } from '../hooks/projects/queries';

// Create the context
const ProjectModalContext = createContext();

/**
 * Provider component that manages the project modal state
 */
export function ProjectModalProvider({ children }) {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const queryClient = useQueryClient();

  const showProjectModal = useCallback(() => {
    // Invalidate projects to ensure fresh data when modal opens
    queryClient.invalidateQueries({ queryKey: projectKeys.all });
    setIsModalVisible(true);
  }, [queryClient]);

  const hideProjectModal = useCallback(() => {
    setIsModalVisible(false);
  }, []);

  const value = {
    isModalVisible,
    showProjectModal,
    hideProjectModal,
  };

  return (
    <ProjectModalContext.Provider value={value}>
      {children}
    </ProjectModalContext.Provider>
  );
}

/**
 * Hook to use the project modal context
 */
export function useProjectModal() {
  const context = useContext(ProjectModalContext);
  if (!context) {
    throw new Error('useProjectModal must be used within a ProjectModalProvider');
  }
  return context;
}

export default ProjectModalContext;